import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { unfollowFund } from 'src/services/wallet';
import {
  FOLLOWED_FUNDS_QUERY_PREFIX,
  FOLLOWING_FIC_DASHBOARD_SUMMARY_QUERY_PREFIX,
} from 'src/services/wallet/queryKeys';

import { MONITOR_LIMITS_QUERY_KEY } from './useMonitorLimits';

interface UseUnfollowFicOptions {
  onSuccess?: () => void;
}

export function useUnfollowFic({ onSuccess }: UseUnfollowFicOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (operationId: string) => unfollowFund(operationId),
    onSuccess: (response) => {
      if (!response?.success) {
        toast.error(
          response?.error || 'Não foi possível parar de seguir este FIC.',
        );
        return;
      }

      queryClient.invalidateQueries(FOLLOWED_FUNDS_QUERY_PREFIX);
      queryClient.invalidateQueries(
        FOLLOWING_FIC_DASHBOARD_SUMMARY_QUERY_PREFIX,
      );
      queryClient.invalidateQueries(MONITOR_LIMITS_QUERY_KEY);
      toast.success('Você deixou de seguir esta operação.');
      onSuccess?.();
    },
    onError: () => {
      toast.error(
        'Não foi possível parar de seguir este FIC. Tente novamente.',
      );
    },
  });
}
